import { toCommunityAvatarSource } from './to-community-avatar-source';

/** ヘッダー切替用。所属一覧を `{ id, name, iconUrl }` に揃える。 */
export function toSwitcherCommunities(
  supabaseUrl: string,
  list: Array<{
    id: string;
    name: string;
    iconPath?: string | null;
    iconUpdatedAt?: string | Date | null;
  }>,
): Array<{ id: string; name: string; iconUrl: string | null }> {
  return list.map((c) => toCommunityAvatarSource(supabaseUrl, c));
}
